import { render } from "./Admin.vue?vue&type=template&id=cf4bfb32"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\saidd\\OneDrive\\Desktop\\AKSA\\Projekti\\udruzenje pravobranilaca\\Admin\\vue-notus\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__